module.exports = __webpack_public_path__ + "img/user_logo.f425933a.png";